/**
 *	In dieser Datei können für verschiedene Environments,
 *  basierend auf dem jeweiligen hostname, angelegt werden.
 *  Für die verschiedeneen Environments können Key-Value-Pairs
 *  hinterlegt werden.
 *  
 *  Das ist z.B. sinnvoll, wenn die locale Dev-Umgebung 
 *  eine andere Rest-API benötigt als die Live-Umgebung.
 */

export default [
	{	
		name     : 'local',
		hostname : 'localhost', 
		restHost : 'http://url-here'
	},
	{	
		name     : 'local2',
		hostname : 'abtei-st-stephan.local', 
		restHost : 'http://url-here'
	},
	{	
		name     : 'beta',
		hostname : 'abtei-st-stephan.de.w01ad5c5.kasserver.com',
		restHost : 'http://url-here'
	},
	{	
		name     : 'live',
		hostname : '', 		
		restHost : ''
	},
]
